window.TracyMaxAjaxRows = 4


if $('#trackers').length
  run_gps_tracker()
  check_start_time(15000)

  checkOrderStatus()

  if active_ride()
    track_position(5000)
    run_timer(1000)
    start_taxametr(1000)
    check_messages(15000)
    
  else
    track_position(15000)
    check_messages(15000)
    check_planned_ride(5000)
    check_order_status(30000)

  navigation()

  addSecond(0)

  reload_ride();



$('#restart_gps_watch').click ->
  restart_gps_tracker()


$('#connection').click ->
  if $(@).hasClass('online')
      $(@).removeClass('online')
      $(@).addClass('offline')
  else
      $(@).removeClass('offline')
      $(@).addClass('online')
  false

$('#reloading').click ->
  if $(@).hasClass('on')
      $(@).removeClass('on')
      $(@).addClass('off')
  else
      $(@).removeClass('off')
      $(@).addClass('on')
  false


